<template>
  <section>
    <div class="headline-cover" v-if="!isFileVideo">
      <span class="headline-upload-cover"
        >YOU’LL TOKENIZE A {{ selectedFileExtension }}</span
      >
      <span class="second-headline-upload-cover">CHOOSE A COVER IMAGE</span>
    </div>

    <file-input
      v-model="localCoverImageFile"
      id="coverImageFile"
      name="coverImageFile"
      accept="image/png,image/jpeg,image/gif"
      :shouldPickCoverImage="true"
      :isImageOnly="true"
      :showPreviewMessage="false"
      :on-change="onFileChanged"
    />
    <div
      v-show="localCoverImageFileSelected && fileType === 'image'"
      class="form-box-buttons-controls"
    >
      <app-button
        text="Back"
        @click.prevent="removeCoverImage()"
        buttonClass="app-modal-button"
      />
      <app-button
        text="Next"
        type="submit"
        form="mint-nft"
        buttonClass="app-modal-button-inverse"
      />
    </div>
  </section>
</template>

<script>
import FileInput from "@/elements/FileInput.vue";
import AppButton from "@/elements/AppButton";
import { computed, ref } from "vue";
import store from "@/store";
import useMinting from "../../composables/useMinting";
import useUtilities from "@/composables/useUtilities";

export default {
  name: "MintNftStepTwo",
  components: {
    FileInput,
    AppButton,
  },
  setup(_props, context) {
    const localCoverImageFile = ref({});
    const {
      decrementStep,
      coverImageFile,
      setBackgroundUrl,
      selectedFileType,
      updateSelectedFile,
      selectedFileMimeType,
      selectedFileExtension,
      updateCoverImageFile,
      isCoverAutogenerated,
    } = useMinting(store);
    const isFileVideo = ref(false);

    const { getFileType } = useUtilities();
    const fileType = computed(() => getFileType(localCoverImageFile.value));

    const localCoverImageFileSelected = computed(() =>
      Boolean(localCoverImageFile.value.type)
    );
    fileType.value === "video"
      ? (isFileVideo.value = true)
      : (isFileVideo.value = false);
    if (coverImageFile.value.name)
      localCoverImageFile.value = coverImageFile.value;

    const removeCoverImage = async () => {
      store.dispatch("minting/clearErrors");
      updateCoverImageFile({});
      setBackgroundUrl("");

      if (
        selectedFileType.value === "video" ||
        selectedFileType.value === "application"
      ) {
        await updateSelectedFile({});
        context.emit("clearFile:selectedImage");
      }
      decrementStep();
    };

    const onFileChanged = (file) => {
      updateCoverImageFile(file);
      if (file.type && !isCoverAutogenerated.value) {
        setBackgroundUrl(URL.createObjectURL(file));
      }
    };

    return {
      onFileChanged,
      removeCoverImage,
      localCoverImageFile,
      selectedFileMimeType,
      selectedFileExtension,
      localCoverImageFileSelected,
      fileType,
      isFileVideo,
    };
  },
};
</script>
<style lang="scss" scoped src="@/Common/Styles/fileInput.scss"></style>
